import { _ as __assign } from './_tslib-ff3a08af.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { D as DropdownIndicator } from './DropdownIndicator-00a8b4ed.js';
import Select from 'react-select';
import { makeStyles, createStyles, lighten } from '@material-ui/core';
import './globalButtonStyles-41c8af84.js';
import { s as styleConstants } from './constants-3b80be2a.js';
import 'react';
import { isNil } from 'lodash';

var defaultSelectStyles = {
    control: function (base, state) {
        return __assign(__assign({}, base), { boxShadow: 'none', border: 'none', '&:focus': { boxShadow: 'none' }, minWidth: '225px', color: 'red', fontWeight: 700 });
    },
    valueContainer: function (base, state) {
        return __assign(__assign({}, base), { paddingTop: '0px' });
    },
    input: function (base, state) {
        return __assign(__assign({}, base), { fontWeight: 700, margin: '0px', '& input': {
                fontWeight: 700,
                fontSize: '16px',
                fontFamily: 'Ubuntu Sans, sans-serif',
                lineHeight: '20px',
                letterSpacing: '0.89px'
            } });
    },
    clearIndicator: function (base, state) {
        return __assign(__assign({}, base), { padding: 0 });
    },
    multiValue: function (base, state) {
        return __assign(__assign({}, base), { backgroundColor: styleConstants.colors.primaryColor, borderRadius: '5px' });
    },
    multiValueLabel: function (base, state) {
        return __assign(__assign({}, base), { color: styleConstants.colors.white });
    },
    multiValueRemove: function (base, state) {
        return __assign(__assign({}, base), { color: styleConstants.colors.white, ':hover': {
                backgroundColor: lighten(styleConstants.colors.primaryColor, 0.3),
                color: 'white',
                cursor: 'pointer',
                borderRadius: '5px'
            } });
    }
};
var useCustomSelectStyles = makeStyles(function (theme) {
    var _a;
    return createStyles({
        filterContainer: (_a = {
            alignItems: 'center',
            backgroundColor: '#fff',
            border: '2px solid',
            borderRadius: '5px',
            display: 'flex',
            flex: '1',
            fontFamily: 'Ubuntu Sans, sans-serif',
            fontWeight: 600,
            minWidth: '325px',
            zIndex: 1300
        }, _a[theme.breakpoints.down('xs')] = {
            minWidth: '265px'
        }, _a['& .select__control'] = {
            backgroundColor: 'transparent'
        }, _a),
        borderCol: {
            borderColor: '#DDDDDD'
        },
        borderColNew: {
            borderColor: styleConstants.colors.primaryColor
        },
        select: {
            flex: '1',
            '&:before': {
                borderColor: '#fff'
            },
            '&:after': {
                borderColor: '#fff'
            },
            '&:hover': {
                borderColor: '#fff'
            },
            '&:hover:not(.Mui-disabled):before': {
                borderBottom: '0'
            },
            '& .MuiSelect-select:focus': {
                backgroundColor: '#fff'
            }
        },
        disabled: {
            backgroundColor: '#f2f2f2'
        },
        error: {
            borderColor: 'red'
        }
    });
});

var CustomSelect = function (_a) {
    var options = _a.options,
        value = _a.value,
        onChange = _a.onChange,
        _b = _a.label,
        label = _b === void 0 ? null : _b,
        optionsWidth = _a.optionsWidth,
        className = _a.className,
        customMenuPlacement = _a.customMenuPlacement,
        placeholder = _a.placeholder,
        minWidth = _a.minWidth,
        isDisabled = _a.isDisabled,
        isError = _a.isError,
        customStyles = _a.customStyles,
        onBlur = _a.onBlur,
        clearable = _a.clearable,
        newEditableLook = _a.newEditableLook,
        _c = _a.dataTestId,
        dataTestId = _c === void 0 ? undefined : _c;
    var classes = useCustomSelectStyles({});
    var isMultiSelect = Array.isArray(value);
    return jsxs("div", { className: "".concat(classes.filterContainer, " ").concat(newEditableLook && !isDisabled ? classes.borderColNew : classes.borderCol, " ").concat(isDisabled ? classes.disabled : '', " ").concat(isError ? classes.error : '', " ").concat(className), style: { minWidth: "".concat(minWidth ? minWidth + 'px' : '320px') }, "data-testid": dataTestId, children: [!isNil(label) && jsx("span", { style: { marginLeft: '8px' }, children: label }), jsx(Select, { menuPortalTarget: document.body, menuPlacement: customMenuPlacement !== null && customMenuPlacement !== void 0 ? customMenuPlacement : 'auto', components: {
                DropdownIndicator: DropdownIndicator,
                IndicatorSeparator: function () {
                    return null;
                }
            }, className: classes.select, value: value, onChange: function (e) {
                return onChange(e);
            }, style: {
                width: "".concat(optionsWidth ? optionsWidth : '140px'),
                fontWeight: 700
            }, placeholder: placeholder, classNamePrefix: "select", isDisabled: isDisabled, isLoading: false, isClearable: clearable, isRtl: false, isSearchable: false, name: "select", options: options, styles: __assign(__assign(__assign({}, defaultSelectStyles), customStyles || {}), { menuPortal: function (base) {
                    return __assign(__assign({}, base), { zIndex: 9999 });
                } }), onBlur: onBlur, isMulti: isMultiSelect })] });
};

export { CustomSelect as C };
